let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4GNBO")).then(() => parcelRequire('f2AGc'));